import React from 'react';
import PropTypes from 'prop-types';
import PopupLink from './popup-link';

export default function PopupLinkInfo(props) {
    return (
        <PopupLink href={props.href}
            className="button-tertiary">
            <span>{props.children}</span>
            <svg className="icon button-tertiary__icon" width="18" height="18" focusable="false">
                <use xlinkHref="#icon-btn-info"></use>
            </svg>
        </PopupLink>
    );
}

PopupLinkInfo.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.string
};
